export default __webpack_public_path__ + "static/media/e2-keynote.60671d12.jpeg";